export default __webpack_public_path__ + "static/media/partidos.e12ae85d.png";